import controller from "./inline-adder-field.controller";

export default {
    bindings: {
        adaptive: "<?"
    },
    controller
};
